import { useDispatch, useSelector } from "react-redux";
import { Checkbox, Popup } from "semantic-ui-react";
import { ToggleAllTimestamps, ToggleTimestamp } from "../../actions/timestampsActions";
import { AppState } from "../../store/configureStore";
import { ValidationProcess } from "../../store/validationProcess";
//import { timestamps } from "./timestamps";

export const TimestampsSelector = () => {
    const activeTimestamps = useSelector((state: AppState) => state.timestamps.timestamps);
    const timestamps = useSelector((state: AppState) => state.validationProcess.availableTimestampsOrScenarios);
    const validationProcess = useSelector((state: AppState) => state.validationProcess.process);
    const dispatch = useDispatch();

    return (
        <div id="div-timestamps-container" className="timestamps-container">
            <p id="p-select-timestamps">Select {validationProcess === ValidationProcess.Ltcc ? "scenarios" : "timestamps"}</p>
            <div id="div-timestamps-selector" className="timestamps-selector">
                {timestamps.map((timestamp, index) => {
                    const checkBox = <Checkbox
                        id={`checkbox-timestamps-${index}`}
                        key={timestamp.key}
                        className="timestamp-checkbox"
                        //checked={activeTimestamps.includes(timestamp)}
                        checked={activeTimestamps.some(ts => ts.key === timestamp.key)}
                        label={timestamp.text}
                        onClick={() => dispatch(ToggleTimestamp(timestamp))}
                    />
                    return timestamp.popupdescription !== undefined ? <Popup key={timestamp.key} style={{ zIndex: 9999 }} id={`checkbox-timestamps22-${index}`} content={timestamp.popupdescription} trigger={
                        checkBox} /> : checkBox
                }
                )}
                <Checkbox
                    id="checkbox-timestamps-select"
                    className="timestamps-selector"
                    onClick={() => dispatch(ToggleAllTimestamps(timestamps))}
                    /*
                    checked={activeTimestamps.length === 24}
                    label={activeTimestamps.length < 24 ? "Select all" : "Deselect all"}
                    */
                    checked={activeTimestamps.length === timestamps.length}
                    label={activeTimestamps.length < timestamps.length ? "Select all" : "Deselect all"}
                />
            </div>
        </div>
    );
};  
